export default __webpack_public_path__ + "static/media/NoResults.41ade0ad.png";